import { GridItem } from "@octopus-energy/coral/atoms"
import { storyblokEditable } from "@octopus-energy/coral/storyblok"
import { FadeIn, Text } from "@/features/greenEnergy"
import { type SbBlokGreenEnergyRenewable } from "../../types"

interface DynamicRenewableEnergyProps {
    blok: SbBlokGreenEnergyRenewable
}

export default function DynamicRenewableEnergy({ blok }: DynamicRenewableEnergyProps) {
    return (
        <GridItem
            gridRowStart={{ base: 2, xl: 1 }}
            gridColumnStart={{ base: 1, xl: 5 }}
            gridRowEnd={{ base: 3, xl: 2 }}
            gridColumnEnd={{ base: 3, xl: 6 }}
            justifySelf={{ base: undefined, xl: "flex-end" }}
            alignSelf={{ base: undefined, xl: "flex-end" }}
        >
            <FadeIn {...storyblokEditable(blok)}>
                <Text>{blok.text}</Text>
            </FadeIn>
        </GridItem>
    )
}
